import { ProductType } from 'components/registry/types/api';
import { RowEditTableWrapperColumns } from 'components/TableWrapper/components/RowEditTableWrapper/types';

export const getColumns = (): RowEditTableWrapperColumns[] => [
  {
    dataFormatter: (item) => item.series,
    key: 'series',
    title: 'Учётная серия №',
    enableSort: false,
    enableFilter: false,
    productTypes: [ProductType.feed],
  },
  {
    dataFormatter: (item) => item.regNumber,
    key: 'regNumber',
    title: 'Регистрационный №',
    enableSort: false,
    enableFilter: false,
    productTypes: [ProductType.feed, ProductType.gmo],
  },
  {
    dataFormatter: (item) =>
      `${item.regNumber}${item.series ? ` (учетная серия ${item.series})` : ''}`,
    key: 'regNumber',
    title: 'Регистрационный №',
    enableSort: false,
    enableFilter: false,
    productTypes: [ProductType.gmProduct],
  },
  {
    dataFormatter: (item) => item.startValidityDate,
    key: 'startValidityDate',
    title: 'Дата начала срока действия',
    enableSort: false,
    enableFilter: false,
  },
  {
    dataFormatter: (item) => item.endValidityDate || 'бессрочно',
    key: 'endValidityDate',
    title: 'Дата окончания срока действия',
    enableSort: false,
    enableFilter: false,
  },
];
